<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>详情</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" >
      <a-form-model-item prop="videoTitle" >
        <span slot="label" ><a-tooltip>{{$t('标题')}}<template slot="title">{{$t('标题')}}</template></a-tooltip> </span>
        <a-input v-model="form.videoTitle" :maxLength="100" type="textarea" :placeholder="$t('请输入')+'视频标题'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="videoPic" >
        <span slot="label" ><a-tooltip>{{$t('视频缩略图')}}<template slot="title">{{$t('视频缩略图')}}</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100"  :disabled="true" v-model="form.videoPic" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="videoUrlList" :label="$t('图片')" >
        <oss-upload-multi :is-array-data="true" :max-count="10" :disabled="true" v-model="form.videoUrlList" prefix="goods" :type="form.videoType===1?'video':'img'" />
      </a-form-model-item>
      <a-form-model-item prop="videoType" >
        <span slot="label" ><a-tooltip>{{$t('类型')}}<template slot="title">{{$t('类型')}}</template></a-tooltip> </span>
        <custom-dict-tag :options="customDict.VideoTypeEnum" :color="true" :value="form.videoType"/>
      </a-form-model-item>
      <a-form-model-item prop="videoStatus" >
        <span slot="label" ><a-tooltip>{{$t('状态')}}<template slot="title">{{$t('审核状态')}}</template></a-tooltip> </span>
        <custom-dict-tag :options="customDict.VideoStatusEnum" :color="true" :value="form.videoStatus"/>
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" ><a-tooltip>{{$t('用户编号')}}<template slot="title">{{$t('用户id')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'用户id'" />
      </a-form-model-item>
      <a-form-model-item prop="nickName" >
        <span slot="label" ><a-tooltip>{{$t('用户昵称')}}<template slot="title">{{$t('用户id')}}</template></a-tooltip> </span>
        <a-input v-model="form.nickName" style="width: 100%" :placeholder="$t('请输入')+$t('用户昵称')" />
      </a-form-model-item>
      <a-form-model-item prop="playsNum" >
        <span slot="label" ><a-tooltip>{{$t('播放次数')}}<template slot="title">{{$t('播放次数')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.playsNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'播放次数'" />
      </a-form-model-item>
      <a-form-model-item prop="likesNum" >
        <span slot="label" ><a-tooltip>{{$t('点赞次数')}}<template slot="title">{{$t('点赞次数')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.likesNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'点赞次数'" />
      </a-form-model-item>
      <a-form-model-item prop="shareNum" >
        <span slot="label" ><a-tooltip>{{$t('分享次数')}}<template slot="title">{{$t('分享次数')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.shareNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'分享次数'" />
      </a-form-model-item>
      <a-form-model-item prop="replyNum" >
        <span slot="label" ><a-tooltip>{{$t('被评论数量')}}<template slot="title">{{$t('被评论数量')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.replyNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'被评论数量'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCommunityVideo, } from '@/api/community/video'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from '@/components/Editor'
import OssUploadMulti from "@/components/OssUploadMulti/index.vue";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    OssUploadMulti,
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        videoTitle: null,
        videoContent: null,
        videoPic: null,
        videoUrlList: null,
        videoType: null,
        videoDuration: null,
        videoStatus: 0,
        relationId: null,
        topicId: null,
        userId: null,
        categoryId: null,
        playsNum: null,
        likesNum: null,
        shareNum: null,
        replyNum: null,
        auditReason: null,
        atUser: null,
        isNeedPay: null,
        needPayAmount: null,
        localeFieldMap:{},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoTitle: null,
        videoContent: null,
        videoPic: null,
        videoUrlList: null,
        videoType: null,
        videoDuration: null,
        videoStatus: 0,
        relationId: null,
        topicId: null,
        userId: null,
        categoryId: null,
        playsNum: null,
        likesNum: null,
        shareNum: null,
        replyNum: null,
        auditReason: null,
        atUser: null,
        isNeedPay: null,
        needPayAmount: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityVideo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    /** 提交按钮 */
  }
}
</script>
